module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flatten-c16c20e53eb8438b85d0147df27cb7e2.svg";